import type { Event } from '~/shared/types'

type Candidate = Pick<Event, 'startTime' | 'endTime' | 'isCanceled' | 'isDraft' | 'status'>

export function runningEvents<T extends Candidate>(events: readonly T[], now: number): T[] {
  return events.filter(
    (event) =>
      !event.isCanceled &&
      !event.isDraft &&
      event.status !== 'Draft' &&
      new Date(event.startTime).getTime() <= now &&
      now <= new Date(event.endTime).getTime(),
  )
}
